import { useCallback } from 'react';
import { IGustoEmployee } from '../../../types/types';
import useGustoAxios from '../../useGustoAxios/useGustoAxios';

export default function useGustoListEmployees() {
  const axios = useGustoAxios();
  return useCallback(
    async (companyId: string) => {
      const result = await axios.get<IGustoEmployee[]>(`/v1/companies/${companyId}/employees`);
      return result.data;
    },
    [axios]
  );
}
